import { render, staticRenderFns } from "./DetailedEnrolment.vue?vue&type=template&id=403cfaf8&"
import script from "./DetailedEnrolment.vue?vue&type=script&lang=js&"
export * from "./DetailedEnrolment.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports